import { adminRpcClient } from '@/providers/backendClient';
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Checkbox,
  Box,
  Typography,
} from '@mui/material';
import { useCallback, useEffect, useState } from 'react';
import { useRefresh } from 'react-admin';

const exportableCollections = [
  { id: 'therapists', name: 'Therapists' },
  { id: 'therapistSessionNotes', name: 'Session Notes' },
  { id: 'appTrackerEvents', name: 'App Tracker Events' },
];

export const CreateDataExportButton = () => {
  const [isOpen, setIsOpen] = useState(false);

  const onOpenDialog = useCallback(() => {
    setIsOpen(true);
  }, []);

  const onCloseDialog = useCallback(() => {
    setIsOpen(false);
  }, []);

  const [selectedCollections, setSelectedCollections] = useState<
    string[]
  >([]);

  useEffect(() => {
    if (!isOpen) {
      return;
    }

    setSelectedCollections([]);
    setIsSaving(false);
  }, [isOpen]);

  const onSelectCollection = useCallback(
    (collection: string) => {
      if (selectedCollections.includes(collection)) {
        setSelectedCollections(
          selectedCollections.filter(c => c !== collection),
        );
      } else {
        setSelectedCollections([...selectedCollections, collection]);
      }
    },
    [selectedCollections],
  );

  const [isSaving, setIsSaving] = useState(false);

  const refresh = useRefresh();

  const onSubmit = useCallback(async () => {
    setIsSaving(true);

    const result: any = await adminRpcClient(
      'PUBLIC_ADMIN_createExport',
      [selectedCollections],
    ).catch(error => {
      alert(`Failed to create data export: ${error.message}`);
      return null;
    });

    if (!result) {
      return;
    }

    if (!result.success) {
      alert(`Failed to create data export: ${result.error}`);
      return;
    }

    await new Promise(resolve => setTimeout(resolve, 30000));

    alert(
      'Export created successfully. Please notice it can take up to a minute for the remote Job to start and the pending request appears down below. When completed, data exports will appear in the `#data-exports` slack channel',
    );

    refresh();

    setIsSaving(false);

    onCloseDialog();
  }, [selectedCollections, onCloseDialog, refresh]);

  return (
    <>
      <Button size="small" onClick={onOpenDialog}>
        Create Data Export
      </Button>
      <Dialog open={isOpen} onClose={onCloseDialog}>
        <DialogTitle>Create Data Export</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Please select the entity you want to export.
          </DialogContentText>
          <Box display="flex" flexDirection="column" gap={2} mt={2}>
            {exportableCollections.map(collection => (
              <label key={collection.id}>
                <Box
                  display="flex"
                  flexDirection="row"
                  alignItems="center"
                  gap={2}
                >
                  <Checkbox
                    checked={selectedCollections.includes(
                      collection.id,
                    )}
                    onChange={() => onSelectCollection(collection.id)}
                  />
                  <Typography>{collection.name}</Typography>
                </Box>
              </label>
            ))}
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={onCloseDialog}>Cancel</Button>
          <Button onClick={onSubmit} disabled={isSaving}>
            {isSaving ? 'Creating...' : 'Create'}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
